import bordeauxMetropole from "@/styles/themes/bordeaux-metropole.css?inline"
import lightBlue from "@/styles/themes/light-blue.css?inline"
import defaultDsfr from "@/styles/themes/default-dsfr.css?inline"
import rosaly from "@/styles/themes/rosaly.css?inline"
import rosaly2024 from "@/styles/themes/rosaly2024.css?inline"
import * as Sentry from "@sentry/vue"
import { ThemeType, ThemeTypeLabel } from "@/../lib/enums/themes.js"

const options = [
  {
    title: ThemeTypeLabel.default,
    label: ThemeType.default,
    value: defaultDsfr,
  },
  {
    title: ThemeTypeLabel.lightBlue,
    label: ThemeType.lightBlue,
    value: lightBlue,
  },
  {
    title: ThemeTypeLabel.bordeauxMetropole,
    label: ThemeType.bordeauxMetropole,
    value: bordeauxMetropole,
  },
  {
    title: ThemeTypeLabel.rosaly,
    label: ThemeType.rosaly,
    value: rosaly,
  },
  {
    title: ThemeTypeLabel.rosaly2024,
    label: ThemeType.rosaly2024,
    value: rosaly2024,
  },
]

export default {
  install: (app) => {
    const styleElement = document.createElement("style")
    styleElement.textContent = rosaly
    document.head.appendChild(styleElement)

    app.config.globalProperties.$theme = {
      current: ThemeType.default,
      options,
      update(newThemeLabel) {
        const match = options.find((option) => option.label === newThemeLabel)
        if (!match) {
          Sentry.captureMessage(`Invalid theme label ${newThemeLabel}`)
          return
        }
        this.current = newThemeLabel
        styleElement.textContent = match.value
      },
    }
  },
}
